import { render, staticRenderFns } from "./CompanyDialog.vue?vue&type=template&id=4605d22c&scoped=true&"
import script from "./CompanyDialog.vue?vue&type=script&lang=js&"
export * from "./CompanyDialog.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDialog.vue?vue&type=style&index=0&id=4605d22c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4605d22c",
  null
  
)

export default component.exports